import React from 'react';
import PropTypes from 'prop-types';
import NavBarMobile from './Mobile';
import NavBarDesktop from './Desktop';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';

const NavBar = ({ mediaIsPhone, mediaIsTablet }) => {
  if (mediaIsPhone || mediaIsTablet) return <NavBarMobile />;
  return <NavBarDesktop />;
};

NavBar.propTypes = {
  // HOC withMediaQueries
  mediaIsPhone: PropTypes.bool.isRequired,
  mediaIsTablet: PropTypes.bool.isRequired,
};

export default withMediaQueries(NavBar);
